import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 max-w-sm w-full sm:w-96"
}
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "flex items-start" }
const _hoisted_4 = { class: "flex-shrink-0" }
const _hoisted_5 = {
  key: 0,
  class: "h-6 w-6 text-green-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_6 = {
  key: 1,
  class: "h-6 w-6 text-red-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_7 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_8 = { class: "ml-4 flex-shrink-0 flex" }




export default /*@__PURE__*/_defineComponent({
  __name: 'DownloadNotification',
  props: {
    show: { type: Boolean },
    type: {},
    message: {},
    resolution: {}
  },
  emits: ['close'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "transition-all duration-300 ease-out",
    "enter-from-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:translate-x-4",
    "enter-to-class": "opacity-100 translate-y-0 sm:translate-x-0",
    "leave-active-class": "transition-all duration-300 ease-in",
    "leave-from-class": "opacity-100 translate-y-0 sm:translate-x-0",
    "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:translate-x-4"
  }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["rounded-lg shadow-lg overflow-hidden", {
          'bg-green-50 dark:bg-green-900/30 border border-green-200 dark:border-green-800': _ctx.type === 'success',
          'bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800': _ctx.type === 'error'
        }])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.type === 'success')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[1] || (_cache[1] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M5 13l4 4L19 7"
                          }, null, -1)
                        ])))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[2] || (_cache[2] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          }, null, -1)
                        ])))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-sm font-medium", {
                'text-green-800 dark:text-green-200': _ctx.type === 'success',
                'text-red-800 dark:text-red-200': _ctx.type === 'error'
              }])
                    }, _toDisplayString(_ctx.message), 3),
                    (_ctx.resolution)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: _normalizeClass(["mt-1 text-sm", {
                'text-green-700 dark:text-green-300': _ctx.type === 'success',
                'text-red-700 dark:text-red-300': _ctx.type === 'error'
              }])
                        }, _toDisplayString(_ctx.resolution), 3))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                      class: "inline-flex text-gray-400 hover:text-gray-500 focus:outline-none"
                    }, _cache[3] || (_cache[3] = [
                      _createElementVNode("span", { class: "sr-only" }, "Close", -1),
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                          "clip-rule": "evenodd"
                        })
                      ], -1)
                    ]))
                  ])
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})